// Academy can be hosted on the same origin as the transcription app.  Never
// reuse its generic authToken/authUser keys, or a login in one product would
// replace the other product's browser session.
export const ACADEMY_AUTH_TOKEN_KEY = 'stenopeAcademyAuthToken';
export const ACADEMY_AUTH_USER_KEY = 'stenopeAcademyAuthUser';
